import { categories } from "@/mocks/news";
import { useFormSubmit } from "@/hooks/useFormSubmit";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dah79f3oh653ivfvnn20";

export default function SubscribeForm() {
  const { status, message, submit } = useFormSubmit({
    submitAddr: SUBMIT_ADDR,
    honeypotName: "website_alt",
    successMessage: "订阅成功！今日热榜摘要会发送到你的邮箱。",
  });

  return (
    <section aria-label="订阅快讯通知" className="w-full">
      <div className="rounded-lg bg-secondary-900 px-5 md:px-10 py-8 md:py-12 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-accent-400 mb-3">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-notification-3-line"></i>
            </span>
            快讯通知
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-black text-background-50 tracking-tight leading-snug">
            订阅今日快讯，热点不再错过
          </h2>
          <p className="mt-3 text-sm text-background-200/90 leading-relaxed">
            每天一封热榜摘要，重大事件即时提醒。频率可控，随时可以停止接收。
          </p>
          <ul className="mt-5 flex flex-col gap-2.5">
            {["当日热榜摘要，三分钟看完", "突发热点第一时间提醒", "不频繁打扰，可随时退订"].map((item) => (
              <li key={item} className="flex items-center gap-2.5 text-sm text-background-100">
                <span className="w-4 h-4 flex items-center justify-center text-accent-400">
                  <i className="ri-check-line"></i>
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        <form id="subscribe-form" data-readdy-form onSubmit={submit} className="w-full flex flex-col gap-3">
          <div className="flex flex-col gap-1.5">
            <label htmlFor="subscribe-email" className="text-xs text-background-200">
              订阅邮箱
            </label>
            <input
              id="subscribe-email"
              name="email"
              type="email"
              required
              placeholder="you@example.com"
              autoComplete="email"
              className="w-full h-11 px-4 rounded-md bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 border border-transparent focus:border-accent-400 focus:outline-none"
            />
          </div>

          <div className="flex flex-col gap-1.5">
            <label htmlFor="subscribe-channel" className="text-xs text-background-200">
              想关注的频道（可多选时请分别订阅）
            </label>
            <select
              id="subscribe-channel"
              name="channel"
              className="w-full h-11 px-3 rounded-md bg-background-50 text-sm text-foreground-900 border border-transparent focus:border-accent-400 focus:outline-none cursor-pointer"
            >
              <option value="全部频道">全部频道</option>
              {categories.map((cat) => (
                <option key={cat.slug} value={cat.name}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>

          <input
            type="text"
            name="website_alt"
            className="contact-note-extra"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />

          <button
            type="submit"
            disabled={status === "submitting"}
            className="mt-1 inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap"
          >
            {status === "submitting" ? "提交中…" : "立即订阅快讯"}
          </button>

          {message && (
            <p
              role="status"
              className={`text-xs leading-relaxed ${status === "success" ? "text-accent-300" : "text-primary-300"}`}
            >
              {message}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}